import { ArrowDown } from "lucide-react";
import { HERO_IMAGE } from "@/data/clubMedia";

const HERO_BG = HERO_IMAGE;

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_barcelona-club-hub/artifacts/9yydi0mf_Logotipo-La-Bombonera-%28Curvas%29.png";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100svh] flex flex-col justify-end overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Estadio en partido nocturno"
          className="w-full h-full object-cover slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-[#030712]/70 to-[#030712]/30" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_70%,rgba(11,29,58,0.6),transparent_60%)]" />
      </div>

      {/* Top label rail */}
      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 md:px-10 lg:px-16 pt-32 md:pt-40">
        <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.32em] text-white/55 reveal">
          <span className="font-mono">N° 015 · TEMPORADA 25/26</span>
          <span className="hidden md:inline font-mono">41.3851° N — 2.1734° E</span>
        </div>
      </div>

      {/* Title block */}
      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 md:px-10 lg:px-16 pb-16 md:pb-24 pt-16 md:pt-24">
        <div className="reveal" style={{ animationDelay: "0.1s" }}>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#FFB800] mb-6 flex items-center gap-3">
            <span className="h-px w-10 bg-[#FFB800]" />
            Club Deportivo · Barcelona
          </p>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <h1
            className="font-display font-extrabold uppercase tracking-[-0.03em] leading-[0.85] text-[clamp(64px,16vw,120px)] md:text-[14vw] lg:text-[10.5rem] reveal"
            style={{ animationDelay: "0.25s" }}
          >
            La<br />
            <span className="text-[#FFB800] italic font-light">Bombo</span>nera
          </h1>

          <div
            className="flex items-end gap-6 reveal"
            style={{ animationDelay: "0.5s" }}
          >
            <img
              src={LOGO_URL}
              alt="Escudo C.D. La Bombonera"
              className="h-28 md:h-36 w-28 md:w-36 object-contain drop-shadow-[0_10px_30px_rgba(255,184,0,0.15)]"
            />
            <div className="flex flex-col leading-tight pb-2">
              <span className="text-[10px] uppercase tracking-[0.3em] text-white/50">Desde</span>
              <span className="font-display font-extrabold text-5xl text-white">2015</span>
              <span className="text-[10px] uppercase tracking-[0.3em] text-white/50">Barcelona</span>
            </div>
          </div>
        </div>

        <div
          className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-end reveal"
          style={{ animationDelay: "0.7s" }}
        >
          <p className="md:col-span-6 text-white/70 text-lg md:text-xl font-light leading-relaxed max-w-xl">
            Más que un club: un manifiesto. Elegimos el deporte como estilo de
            vida y formamos a quienes lo viven con <span className="text-white">valor</span>.
          </p>

          <div className="md:col-span-6 flex flex-wrap gap-4 md:justify-end items-center">
            <a href="#about" data-testid="hero-cta-primary" className="btn-primary">
              Conocé el club
              <ArrowDown size={14} />
            </a>
            <a href="#contacto-form" data-testid="hero-cta-secondary" className="btn-secondary">
              Contáctanos
            </a>
          </div>
        </div>
      </div>

      {/* Bottom marquee strip */}
      <div className="relative z-10 border-t border-white/10 bg-[#030712]/40 backdrop-blur-sm overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap py-4">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex items-center gap-12 px-6 text-[11px] uppercase tracking-[0.4em] text-white/45 font-mono">
              {[
                "Valor",
                "★",
                "Profesionalidad",
                "★",
                "Identidad",
                "★",
                "Comunidad",
                "★",
                "Pasión",
                "★",
                "Disciplina",
                "★",
              ].map((t, i) => (
                <span key={i} className={t === "★" ? "text-[#FFB800]" : ""}>{t}</span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
